import { API_URL } from "constants";
import { apiRequest } from "./apiRequest";

export const getUrl = (eventId) => `${API_URL}/api/v2/appointments/cancel?id=${eventId}`;

export const cancelAppointment = async (eventId) => {
    const url = getUrl(eventId);
    return await apiRequest(url, "post");
};
